module.exports = __webpack_public_path__ + "static/Fastigo_Logo-9075e2c5bca316b6fb9cb96b77d988f0.svg";